import { VideoPlayerType } from './../../../../models/camera.model';
import { AppConfig } from './../../../../app.config';
import { SensorCoreObject } from './../../../../asp/SensorCoreObject';
import { VideoMsgMngrService } from '@core_n/msg/video-mngr.service';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';


@Component({
  selector: 'show-video-player',
  templateUrl: './show-video-player.component.html',
  styleUrls: ['./show-video-player.component.scss']
})
export class ShowVideoPlayerComponent implements OnInit {

  @Input() playerId: number;
  @Input() sensor: SensorCoreObject | null = null;
  @Input() fixedCamera: boolean = false;
  @Input() disableViewPoints: boolean = false;
  @Input() disablePlayback: boolean = false;

  public videoPlayerType : VideoPlayerType = AppConfig.settings.videoAddress.videoPlayerInfo?.type ?? "jwPlayer";
  public videoErrorMessage: string = null;
  public videoLoading: boolean = false;
  public viewpointsCamera: any[];

  private _camera: any;
  public viewpoints:any ;
  public isViewPoints: boolean = false;
  public _VideoLayout:any;

  public noVideoSvg = './assets/Images/video.svg';

  constructor(protected videomngr: VideoMsgMngrService) { }

  get streamName(){
    return this.sensor.streamName.endsWith(".stream") ? this.sensor.streamName.replace(".stream", "") : this.sensor.streamName;
  }

  public onCameraDropped($event: { element: any , event: DragEvent }): void {

    const newCamera: any  = $event.element.data.sourceNode.sourceData;

  }

  public onVideoSelected() {}

  ngOnInit(): void {
    this.loadEntities()
  }

  ngOnChanges(changes: SimpleChanges){
  }


  public get camera(): any {
    return this._camera;
  }
  public set camera(value: any) {
    this._camera = value;
  }


  loadEntities(): void {

      this.viewpoints = AppConfig.presets; 

      let lstorder = this.viewpoints.filter(x => x.orderInRound);
         if (lstorder.length > 1) {
           this.isViewPoints = true;
         }
         else {
           this.isViewPoints = false;
         }


         if (this._camera != null) {
           this.viewpointsCamera = this.viewpoints.filter(viewpontdata => viewpontdata.cameraId == this._camera.id).sort((a, b) => a.orderInRound - b.orderInRound);
      }
    
  }
}
